import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 11.821c-.981 0-1.866.406-2.501 1.057L9 15.379l2.501-2.501A3.483 3.483 0 0 0 9 11.821zM9 8.746a6.552 6.552 0 0 0-4.677 1.956l.852.852a5.35 5.35 0 0 1 7.65 0l.852-.852A6.552 6.552 0 0 0 9 8.746z" />
    <path d="M9 5.721a9.57 9.57 0 0 0-6.816 2.842l.851.851C4.559 7.876 6.669 6.921 9 6.921s4.441.955 5.965 2.493l.851-.851A9.57 9.57 0 0 0 9 5.721z" />
    <path d="M9 2.621c-3.518 0-6.7 1.431-9 3.742v.017l.844.844C2.929 5.124 5.815 3.821 9 3.821s6.071 1.303 8.156 3.403L18 6.379v-.017a12.66 12.66 0 0 0-9-3.741z" />
  </svg>
);

export default SvgComponent;
